/**
 * 상세 CTA 전화번호 결정 (v2, 2026-09-21 대표 결정 5).
 *
 * 순서:
 *   1. is_side_inquiry === true (담당자 없는 현장) → 대표번호 1533-8124 고정
 *   2. contact_number (담당자 현장번호) — 숫자 정규화 후 유효할 때
 *   3. model_house_phone — 숫자 정규화 후 유효할 때
 *   4. 대표번호 1533-8124
 *
 * 정규화: 숫자만 추출 후
 *   8자리 → 4-4 (1533-8124), 10자리 → 02 이면 2-4-4 / 그 외 3-3-4,
 *   11자리 → 3-4-4, 그 외 길이는 무효(다음 후보로).
 */
import { INQUIRY_PHONE, INQUIRY_PHONE_RAW } from './PHONE';

export interface ContactPhone {
  /** 화면 표시용 (하이픈 포함) */
  display: string;
  /** tel: 링크 (숫자만) */
  tel: string;
  /** 대표번호로 폴백됐는지 */
  isDefault: boolean;
}

export interface ContactPhoneSource {
  is_side_inquiry?: boolean | null;
  contact_number?: string | null;
  model_house_phone?: string | null;
}

export const DEFAULT_CONTACT_PHONE: ContactPhone = {
  display: INQUIRY_PHONE,
  tel: `tel:${INQUIRY_PHONE_RAW}`,
  isDefault: true,
};

/** 번호 정규화. 유효하지 않으면 null. */
export function normalizePhone(raw: string | null | undefined): { display: string; digits: string } | null {
  if (!raw) return null;
  const d = String(raw).replace(/\D/g, '');
  let display: string | null = null;
  if (d.length === 8) display = `${d.slice(0, 4)}-${d.slice(4)}`;
  else if (d.length === 10 && d.startsWith('02')) display = `${d.slice(0, 2)}-${d.slice(2, 6)}-${d.slice(6)}`;
  else if (d.length === 10) display = `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
  else if (d.length === 11) display = `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`;
  return display ? { display, digits: d } : null;
}

export function resolveContactPhone(p: ContactPhoneSource | null | undefined): ContactPhone {
  if (!p || p.is_side_inquiry === true) return DEFAULT_CONTACT_PHONE;
  for (const cand of [p.contact_number, p.model_house_phone]) {
    const n = normalizePhone(cand);
    if (n) {
      const isDefault = n.digits === INQUIRY_PHONE_RAW;
      return { display: n.display, tel: `tel:${n.digits}`, isDefault };
    }
  }
  return DEFAULT_CONTACT_PHONE;
}
